"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findGraphQlConfiguration = findGraphQlConfiguration;
exports.extractGraphQlMetadata = extractGraphQlMetadata;
const browser_core_1 = require("@datadog/browser-core");
/**
 * arbitrary value, byte precision not needed
 */
const GRAPHQL_PAYLOAD_LIMIT = 32 * browser_core_1.ONE_KIBI_BYTE;
function findGraphQlConfiguration(url, configuration) {
    return configuration.allowedGraphQlUrls.find((graphQlOption) => (0, browser_core_1.matchList)([graphQlOption.match], url));
}
function extractGraphQlMetadata(requestBody, trackPayload = false) {
    if (!requestBody || typeof requestBody !== 'string') {
        return;
    }
    let graphqlBody;
    try {
        graphqlBody = JSON.parse(requestBody);
    }
    catch (_a) {
        // Not valid JSON
        return;
    }
    if (!graphqlBody || !graphqlBody.query) {
        return;
    }
    const query = graphqlBody.query.trim();
    const operationType = getOperationType(query);
    const operationName = graphqlBody.operationName;
    if (!operationType) {
        return;
    }
    let variables;
    if (graphqlBody.variables) {
        variables = JSON.stringify(graphqlBody.variables);
    }
    return {
        operationType,
        operationName,
        variables,
        payload: trackPayload ? (0, browser_core_1.safeTruncate)(query, GRAPHQL_PAYLOAD_LIMIT, '...') : undefined,
    };
}
function getOperationType(query) {
    var _a;
    return (_a = query.match(/^\s*(query|mutation|subscription)\b/i)) === null || _a === void 0 ? void 0 : _a[1];
}
//# sourceMappingURL=graphql.js.map